export default "__VITE_ASSET__CyDNYcld__"